export default __webpack_public_path__ + "i18n/translations/translation-ja.ce1390d9.json";